import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

@Component({
  selector: 'modal-video',
  templateUrl: 'modal-video.html'
})
export class ModalVideoComponent implements OnInit {

  material: any;
  isLoading: boolean;
  @ViewChild('videoPlayer') videoPlayer: ElementRef;

  constructor(
    private screenOrientation: ScreenOrientation
  ) {
    this.isLoading = false;
  }


  ngOnInit(): void {  }

  show(material) {
    this.material = material;

    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
  }

  play() {
    this.isLoading = true;
    var elem = this.videoPlayer.nativeElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { 
      elem.msRequestFullscreen();
    }

    elem.load();

    elem.onloadstart = () => {
      console.log("Starting to load video");
    };
    
    elem.onpause = () => {
      this.isLoading = false;
    };
  
    elem.onplay = () => {
      this.isLoading = true;
    };
    
    elem.oncanplay = () => {
      this.isLoading = false;
      elem.play();
    };
  }

  close() {
    this.isLoading = false;
    this.material = null;
    this.screenOrientation.unlock();
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-video/modal-video.ts